import { render, staticRenderFns } from "./SelectKeyword.vue?vue&type=template&id=133d4ba1&scoped=true&"
import script from "./SelectKeyword.vue?vue&type=script&lang=ts&"
export * from "./SelectKeyword.vue?vue&type=script&lang=ts&"
import style0 from "./SelectKeyword.vue?vue&type=style&index=0&id=133d4ba1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133d4ba1",
  null
  
)

export default component.exports